// recentQuestions persists the last few questions the user asked the assistant,
// so the ask box can offer them as quick re-asks. Stored in localStorage (per
// browser), newest-first, de-duplicated, capped at MAX. All access is guarded
// so a disabled/unavailable localStorage never throws.

const KEY = "instantview.assistant.recentQuestions";
const MAX = 5;

export function getRecentQuestions() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((q) => typeof q === "string").slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecentQuestion(question) {
  const q = (question || "").trim();
  if (!q) return;
  try {
    const next = [q, ...getRecentQuestions().filter((x) => x !== q)].slice(0, MAX);
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable (private mode / quota) — recents are best-effort.
  }
}
